import style from './PickupListingView.css';
import Title from '../../../components/shared/Typography/Title';
import useTranslation from '../../../localization/i18n.context';
import List from '../../../components/shared/List/List';
import ListItem from '../../../components/shared/List/ListItem';
import Alert from '../../../components/shared/Alert/Alert';
import BodyText from '../../../components/shared/Typography/BodyText';
import NavigationUtils from '../../../utils/navigation.utils';
import RemoteIcon from '../../../components/shared/RemoteIcon/RemoteIcon';
import { PickupType, PickupListingProvider } from '../PickupProvider';

export default function PickupListingView({
  locations = [],
  type = PickupType.DEBIT,
}) {
  const { t } = useTranslation();
  const data = PickupListingProvider(t)[type];

  return (
    <main className={style.main}>
      <div className={style.head}>
        <Title text={data.title} />
        <BodyText text={data.text} className={style.subtitle} />
      </div>

      <Alert hasIcon message={data.alert} className={style['info-box']} />

      <List className={style.content} data-testid="merchant-list">
        {locations.map(el => {
          const Icon = el.icon ? (
            <RemoteIcon width={40} height={40} src={el.icon} />
          ) : null;

          return (
            <ListItem
              title={el.name}
              key={el.id}
              icon={Icon}
              actionable
              size={ListItem.Size.SMALL}
              onClick={() => {
                NavigationUtils.navigate(
                  NavigationUtils.Routes.PICKUP_DETAIL,
                  false,
                  { id: el.id, name: encodeURI(el.name) },
                );
              }}
              data-testid="merchant"
            />
          );
        })}
      </List>
    </main>
  );
}
